import request from 'ynf-core-engine/request'
import { configHook } from '@utils'

/**
 * @description: 变更历史查询
 * @param {*} params
 * @param {array} rest
 * @return {*}
 */
export async function changeHistory ({ params = {}, ...rest } = {}) {
  const defaultQuery = {
    params: {
      feV: 6
    }
  }
  defaultQuery.params = configHook(params, defaultQuery.params)

  try {
    const res = await request({
      method: 'get',
      url: `${_UNIFORM_SERVICE_}/log-pub/business/rest/search/history`,
      ...defaultQuery,
      ...rest
    })
    return res
  } catch (err) {
    return Promise.reject(err)
  }
}